export const data = [
  {
    id:1,
    select:false,
    title:"信用立法研究",
    text:"地方信用立法前期研究与起草，准确把握信用内涵与本质，深度结合地方经济社会发展实际，权威信用专家+资深法律专家领衔。"
  },
  {
    id:2,
    select:false,
    title:"信用经济研究与顶层设计",
    text:"以定制化方案解决什么是信用经济，如何发展信用经济，如何通过信用经济为经济高质量发展和构建新发展格局赋能等重大问题。"
  },
  {
    id:3,
    select:false,
    title:"以信用建设优化营商环境研究",
    text:"准确把握国家优化营商环境政策走向，深入结合当地营商实际，以多元化信用实践为手段，创新描绘优化营商环境的信用路径。"
  },
  {
    id:4,
    select:false,
    title:"信用管理师培训",
    text:"联合信用管理师标准制订单位，常态化开展信用管理师基础知识、职业技能等方面专项培训与辅导工作。"
  },
  {
    id:5,
    select:false,
    title:"协会创新服务方向与路径研究",
    text:"以信用应用为手段，充分发挥行业协会在行业信用建设中的关键性抓手作用，为协会创新业务模式与思路提供专业化定制方案。"
  },
  {
    id:6,
    select:false,
    title:"信用示范创建咨询与辅导",
    text:"为希望参与示范创建以评促建、创建指标纷繁不知从何入手、基础较差或差距较大、缺乏能形成示范的亮点等需求提供专题服务。"
  },
  {
    id:7,
    select:false,
    title:"数字治理机制与路径研究",
    text:"充分发挥数据资产的实质性作用，围绕数字资产定位、管理机制构建、促进数据开放与应用、保护数据隐私等形成深入研究成果。"
  },
  {
    id:8,
    select:false,
    title:"信用评价与预警模型研发",
    text:"大数据、人工智能等新兴技术加持，研发适应当前现实需求、实现精准预测的大数据信用评价模型与预警模型，并开发配套系统。"
  },
  {
    id:9,
    select:false,
    title:"政务诚信与政府公信力研究",
    text:"切合国家政务诚信建设发展导向，结合古今中外政务诚信相关实践经验与理论研究，创新探索政务诚信评价与管理解决方案。"
  },
  {
    id:10,
    select:false,
    title:"街道乡村信用服务与治理研究",
    text:"创新打造街道、乡镇信用治理模式，让社会信用体系建设延伸至基层，将信用嵌入基层治理全过程，提升基层治理能力和水平。"
  },
  {
    id:11,
    select:false,
    title:"企业全流程信用管理方案设计",
    text:"围绕企业现实痛点与实际业务需求，以产业链信用管理为核心，构建具有行业竞争力的企业生产经营全流程信用解决方案。"
  },
  {
    id:12,
    select:false,
    title:"信用监管制度、清单与软件",
    text:"建立以诚信、合规、践约“三维”信用综合 评价为支撑，事前、事中、事后全流程联动 的信用监管模式，制度、清单、模型全配齐。"
  },
  {
    id:13,
    select:false,
    title:"信用仲裁与调解机制构建",
    text:"探索构建以信用为核心的现代化新型仲裁与调解机制，将信用机制与手段贯穿仲裁与调解的全过程，作为法治化的有效补充。"
  },
  {
    id:14,
    select:false,
    title:"“信易+”惠民便企场景设计",
    text:"依托小程序等交互技术，创新设计丰富应用场景，并嵌入全流程信用管理与服务，以信用切实提升市场主体的“获得感”。"
  },
  {
    id:15,
    select:false,
    title:"地方产业信用管理与服务设计",
    text:"依托十余个行业研究经验，以信用手段为地方产业提质增效提供优化方案，并依托产品设计实现产业管理现代化与智能化。"
  },
  {
    id:16,
    select:false,
    title:"企业公信力与社会责任研究",
    text:"深入剖析关键性企业的公信力与社会责任形成机制与路径，探索企业定制化公信力提升与维护的配套实现方案。"
  }
]
